import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'

// Loads all locale messages
function loadLocaleMessages () {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

Vue.use(VueI18n)

// Create a new store
const i18n = new VueI18n({
  locale: store.getters.locale,
  fallbackLocale: process.env.I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages()
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js